import { client } from './client';

// --- In-app Notifications ---

export const getNotifications = async (params = {}) => {
    const cleanParams = Object.fromEntries(
        Object.entries(params).filter(([, v]) => v != null && v !== '')
    );
    const response = await client.get('/v1/notifications', { params: cleanParams });
    return response.data; // { items, pagination }
};

export const markNotificationRead = async (uid) => {
    await client.patch(`/v1/notifications/${uid}/read`);
};

export const markAllNotificationsRead = async () => {
    await client.patch('/v1/notifications/read-all');
};

export const deleteNotification = async (uid) => {
    await client.delete(`/v1/notifications/${uid}`);
};

export const clearNotifications = async (filter) => {
    await client.delete('/v1/notifications', { params: { filter } });
};
